"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isElsysERSC02 = exports.isNanosenseE4000NG = exports.isXovis = exports.isVcount = exports.isTesto = exports.isTechnis = exports.isTerabee = exports.isRubix = exports.isNexelec = exports.isNanosense = exports.isHikvision = exports.isEurecan = exports.isElsys = exports.getBrandId = void 0;
var brand_type_1 = require("../types/brand.type");
var getBrandId = function (modeiId) {
    var brands = Object.entries(brand_type_1.DeviceModelType);
    return brands.find(function (_a) {
        var _b = __read(_a, 2), _ = _b[0], ids = _b[1];
        return ids.includes(modeiId);
    })[0];
};
exports.getBrandId = getBrandId;
var isBrandType = function (modelId, brandId) { return brand_type_1.DeviceModelType[brandId].includes(modelId); };
var isElsys = function (modelId) { return isBrandType(modelId, brand_type_1.BrandId.ELSYS); };
exports.isElsys = isElsys;
var isEurecan = function (modelId) { return isBrandType(modelId, brand_type_1.BrandId.EURECAM); };
exports.isEurecan = isEurecan;
var isHikvision = function (modelId) { return isBrandType(modelId, brand_type_1.BrandId.HIKVISION); };
exports.isHikvision = isHikvision;
var isNanosense = function (modelId) { return isBrandType(modelId, brand_type_1.BrandId.NANOSENSE); };
exports.isNanosense = isNanosense;
var isNexelec = function (modelId) { return isBrandType(modelId, brand_type_1.BrandId.NEXELEC); };
exports.isNexelec = isNexelec;
var isRubix = function (modelId) { return isBrandType(modelId, brand_type_1.BrandId.RUBIX); };
exports.isRubix = isRubix;
var isTerabee = function (modelId) { return isBrandType(modelId, brand_type_1.BrandId.TERABEE); };
exports.isTerabee = isTerabee;
var isTechnis = function (modelId) { return isBrandType(modelId, brand_type_1.BrandId.TECHNIS); };
exports.isTechnis = isTechnis;
var isTesto = function (modelId) { return isBrandType(modelId, brand_type_1.BrandId.TESTO); };
exports.isTesto = isTesto;
var isVcount = function (modelId) { return isBrandType(modelId, brand_type_1.BrandId.VCOUNT); };
exports.isVcount = isVcount;
var isXovis = function (modelId) { return isBrandType(modelId, brand_type_1.BrandId.XOVIS); };
exports.isXovis = isXovis;
var isDevice = function (modelId, referenceId) { return modelId === referenceId; };
var isNanosenseE4000NG = function (modelId) { return isDevice(modelId, brand_type_1.DeviceModelId.NANOSENSE_E4000NG); };
exports.isNanosenseE4000NG = isNanosenseE4000NG;
var isElsysERSC02 = function (modelId) { return isDevice(modelId, brand_type_1.DeviceModelId.ELSYS_ERSCO2); };
exports.isElsysERSC02 = isElsysERSC02;
